import React, { forwardRef, HtmlHTMLAttributes, memo } from "react";
import { EmptyState, EmptyStateIconBackground, EmptyStateIllustrationIcon, EmptyStateProps } from "../EmptyState";

export type AccessDeniedBlockProps = HtmlHTMLAttributes<HTMLDivElement> & EmptyStateProps

export const AccessDeniedBlock = memo(forwardRef<HTMLDivElement, AccessDeniedBlockProps>((
  {
    size = "sm",
    header = "Access forbidden",
    supportingText = "You don't have permission to access this page",
    ...restProps
  },
  ref) => {
  return (
    <EmptyState
      size={size}
      header={header}
      supportingText={supportingText}
      icon={
        <>
          <EmptyStateIconBackground type="circle">
            <EmptyStateIllustrationIcon iconType="CloudGrayMd" />
          </EmptyStateIconBackground>
        </>
      }
      {...restProps}
      ref={ref}
    />
  );
}));